module.exports = __webpack_public_path__ + "img/合约调用.dea98a1c.jpg";